export default "__VITE_ASSET__C51rRtfE__"